import axios from "axios";
import { BASE_API_URL } from "../constants/dropdown";

// Action Types
export const GET_REFERRAL_ANALYTICS_REQUEST = "GET_REFERRAL_ANALYTICS_REQUEST";
export const GET_REFERRAL_ANALYTICS_SUCCESS = "GET_REFERRAL_ANALYTICS_SUCCESS";
export const GET_REFERRAL_ANALYTICS_FAIL = "GET_REFERRAL_ANALYTICS_FAIL";

export const GET_REFERRAL_REFERRERS_REQUEST = "GET_REFERRAL_REFERRERS_REQUEST";
export const GET_REFERRAL_REFERRERS_SUCCESS = "GET_REFERRAL_REFERRERS_SUCCESS";
export const GET_REFERRAL_REFERRERS_FAIL = "GET_REFERRAL_REFERRERS_FAIL";

export const GET_REFERRAL_LEADERBOARD_REQUEST =
  "GET_REFERRAL_LEADERBOARD_REQUEST";
export const GET_REFERRAL_LEADERBOARD_SUCCESS =
  "GET_REFERRAL_LEADERBOARD_SUCCESS";
export const GET_REFERRAL_LEADERBOARD_FAIL = "GET_REFERRAL_LEADERBOARD_FAIL";

export const GET_REFERRER_DETAIL_REQUEST = "GET_REFERRER_DETAIL_REQUEST";
export const GET_REFERRER_DETAIL_SUCCESS = "GET_REFERRER_DETAIL_SUCCESS";
export const GET_REFERRER_DETAIL_FAIL = "GET_REFERRER_DETAIL_FAIL";

export const GET_REFERRAL_DETAIL_REQUEST = "GET_REFERRAL_DETAIL_REQUEST";
export const GET_REFERRAL_DETAIL_SUCCESS = "GET_REFERRAL_DETAIL_SUCCESS";
export const GET_REFERRAL_DETAIL_FAIL = "GET_REFERRAL_DETAIL_FAIL";

export const GET_REFERRAL_LINK_REQUEST = "GET_REFERRAL_LINK_REQUEST";
export const GET_REFERRAL_LINK_SUCCESS = "GET_REFERRAL_LINK_SUCCESS";
export const GET_REFERRAL_LINK_FAIL = "GET_REFERRAL_LINK_FAIL";

export const GET_STAFF_LEADERBOARD_REQUEST = "GET_STAFF_LEADERBOARD_REQUEST";
export const GET_STAFF_LEADERBOARD_SUCCESS = "GET_STAFF_LEADERBOARD_SUCCESS";
export const GET_STAFF_LEADERBOARD_FAIL = "GET_STAFF_LEADERBOARD_FAIL";

export const GET_REFERRAL_STATES_REQUEST = "GET_REFERRAL_STATES_REQUEST";
export const GET_REFERRAL_STATES_SUCCESS = "GET_REFERRAL_STATES_SUCCESS";
export const GET_REFERRAL_STATES_FAIL = "GET_REFERRAL_STATES_FAIL";

export const GET_ALL_REFERRALS_REQUEST = "GET_ALL_REFERRALS_REQUEST";
export const GET_ALL_REFERRALS_SUCCESS = "GET_ALL_REFERRALS_SUCCESS";
export const GET_ALL_REFERRALS_FAIL = "GET_ALL_REFERRALS_FAIL";

export const GET_REFERRAL_TYPES_REQUEST = "GET_REFERRAL_TYPES_REQUEST";
export const GET_REFERRAL_TYPES_SUCCESS = "GET_REFERRAL_TYPES_SUCCESS";
export const GET_REFERRAL_TYPES_FAIL = "GET_REFERRAL_TYPES_FAIL";

// Helper to get auth config
const getConfig = (getState) => {
  const {
    admin2faLogin: { userInfo },
  } = getState();
  const token = userInfo?.token?.access_token;
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
};

// Helper to build query string from params
const buildQuery = (params) => {
  const valid = Object.entries(params).filter(
    ([_, v]) => v !== "" && v !== null && v !== undefined,
  );
  if (valid.length === 0) return "";
  return "?" + valid.map(([k, v]) => `${k}=${v}`).join("&");
};

// Fetch referral analytics
export const fetchReferralAnalytics =
  (fromDate = "", toDate = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_REFERRAL_ANALYTICS_REQUEST });
      const config = getConfig(getState);
      const query = buildQuery({ fromDate, toDate });
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/analytics${query}`,
        config,
      );
      dispatch({ type: GET_REFERRAL_ANALYTICS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: GET_REFERRAL_ANALYTICS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Fetch referrers list
export const fetchReferrers =
  (page = 1, pageSize = 10, fromDate = "", toDate = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_REFERRAL_REFERRERS_REQUEST });
      const config = getConfig(getState);
      const query = buildQuery({ page, pageSize, fromDate, toDate });
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/referrers${query}`,
        config,
      );
      dispatch({ type: GET_REFERRAL_REFERRERS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: GET_REFERRAL_REFERRERS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Fetch leaderboard
export const fetchReferralLeaderboard =
  (page = 1, pageSize = 10, fromDate = "", toDate = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_REFERRAL_LEADERBOARD_REQUEST });
      const config = getConfig(getState);
      const query = buildQuery({ page, pageSize, fromDate, toDate });
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/leaderboard${query}`,
        config,
      );
      dispatch({ type: GET_REFERRAL_LEADERBOARD_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: GET_REFERRAL_LEADERBOARD_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Fetch single referrer detail (with their referrals list)
export const fetchReferrerDetail =
  (referrerId, page = 1, pageSize = 10) => async (dispatch, getState) => {
    try {
      dispatch({ type: GET_REFERRER_DETAIL_REQUEST });
      const config = getConfig(getState);
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/${referrerId}?page=${page}&pageSize=${pageSize}`,
        config,
      );
      dispatch({ type: GET_REFERRER_DETAIL_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: GET_REFERRER_DETAIL_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Fetch single referral detail
export const fetchReferralDetail =
  (referrerId, refereeId) => async (dispatch, getState) => {
    try {
      dispatch({ type: GET_REFERRAL_DETAIL_REQUEST });
      const config = getConfig(getState);
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/${referrerId}/${refereeId}`,
        config,
      );
      dispatch({ type: GET_REFERRAL_DETAIL_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: GET_REFERRAL_DETAIL_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const fetchReferralLink =
  (referrerTag) => async (dispatch, getState) => {
    try {
      dispatch({ type: GET_REFERRAL_LINK_REQUEST })
      const config = getConfig(getState)
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/link?referrerTag=${referrerTag}`,
        config
      )
      dispatch({ type: GET_REFERRAL_LINK_SUCCESS, payload: data })
      return data                                              // ← ADD
    } catch (error) {
      dispatch({
        type: GET_REFERRAL_LINK_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
      })
      throw error                                              // ← ADD
    }
  }

// Fetch staff leaderboard
export const fetchStaffLeaderboard =
  (page = 1, pageSize = 10, fromDate = "", toDate = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_STAFF_LEADERBOARD_REQUEST });
      const config = getConfig(getState);
      const query = buildQuery({ page, pageSize, fromDate, toDate });
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/leaderboard/admin${query}`,
        config,
      );
      dispatch({ type: GET_STAFF_LEADERBOARD_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: GET_STAFF_LEADERBOARD_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Fetch all referrals
export const fetchAllReferrals =
  (page = 1, pageSize = 100, fromDate = "", toDate = "", referrerId = "", refereeId = "", referrerTypeId = "", refereeTypeId = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_ALL_REFERRALS_REQUEST });
      const config = getConfig(getState);
      const query = buildQuery({ page, pageSize, fromDate, toDate, referrerId, refereeId, referrerTypeId, refereeTypeId });
      const { data } = await axios.get(
        `${BASE_API_URL}/admin/referrals/all${query}`,
        config,
      );
      dispatch({ type: GET_ALL_REFERRALS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: GET_ALL_REFERRALS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// Fetch referral types
export const fetchReferralTypes = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_REFERRAL_TYPES_REQUEST });
    const config = getConfig(getState);
    const { data } = await axios.get(
      `${BASE_API_URL}/admin/referrals/type`,
      config,
    );
    dispatch({ type: GET_REFERRAL_TYPES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_REFERRAL_TYPES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Fetch referral states
export const fetchReferralStates = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_REFERRAL_STATES_REQUEST });
    const config = getConfig(getState);
    const { data } = await axios.get(
      `${BASE_API_URL}/admin/referrals/state`,
      config,
    );
    dispatch({ type: GET_REFERRAL_STATES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_REFERRAL_STATES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
